import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import {
	ANALYTICS_CONSENT_EVENT,
	useAnalyticsConsent,
} from "@/lib/analytics-consent";
import { useI18n } from "@/lib/i18n/use-i18n";
import { Button } from "../ui/button";
import { Card } from "../ui/card";

export default function ConsentBanner() {
	const { state, grantConsent, denyConsent } = useAnalyticsConsent();
	const { t, localeParam } = useI18n();
	const [open, setOpen] = useState(false);
	useEffect(() => {
		const show = () => setOpen(true);
		window.addEventListener(ANALYTICS_CONSENT_EVENT, show);
		return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, show);
	}, []);
	if (state === "loading" || (!open && state !== "pending")) return null;
	return (
		<section
			aria-label={t((t) => t.consent.title)}
			className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-6 md:max-w-lg"
		>
			<Card className="p-6">
				<h2 className="text-heading text-lg">{t((t) => t.consent.title)}</h2>
				<p className="text-body-muted mt-2 text-sm">
					{t((t) => t.consent.description)}
				</p>
				<p className="text-body-muted mt-2 text-sm">
					{t((t) => t.consent.retention)}
				</p>
				<Link
					to="/{-$locale}/docs/$slug"
					params={{
						...(localeParam ? { locale: localeParam } : {}),
						slug: "privacy",
					}}
					className="mt-3 inline-block text-sm text-link underline underline-offset-4"
				>
					{t((t) => t.consent.policyLink)}
				</Link>
				<div className="mt-4 flex flex-wrap gap-3">
					<Button
						variant="outline"
						size="sm"
						onClick={() => {
							denyConsent();
							setOpen(false);
						}}
					>
						{t((t) => t.consent.deny)}
					</Button>
					<Button
						variant="outline"
						size="sm"
						onClick={() => {
							grantConsent();
							setOpen(false);
						}}
					>
						{t((t) => t.consent.accept)}
					</Button>
					{open && state !== "pending" ? (
						<Button variant="ghost" size="sm" onClick={() => setOpen(false)}>
							{t((t) => t.consent.close)}
						</Button>
					) : null}
				</div>
			</Card>
		</section>
	);
}
